import React from "react";

const GameLayout = ({ children, pageClassName }) => {
  return <div className={`container ${pageClassName}`}>{children}</div>;
};

export default GameLayout;
